import React from 'react';
import { ArrowLeft, MessageCircle, Search } from 'lucide-react';
import { Link, useSearchParams } from 'react-router-dom';

const SUPPORT_USERNAME = 'freeapp';

const GameRequestPage = () => {
  const [searchParams] = useSearchParams();
  const platform = searchParams.get('platform')?.trim() || 'выбранной платформы';
  const message = `Здравствуйте! Хочу узнать цену и заказать игру для ${platform}.`;
  const telegramHref = `https://t.me/${SUPPORT_USERNAME}?text=${encodeURIComponent(message)}`;

  return (
    <main className="min-h-screen bg-background px-4 py-8 text-foreground sm:py-14">
      <div className="mx-auto max-w-3xl">
        <Link
          to="/"
          className="mb-6 inline-flex items-center gap-2 text-sm text-foreground/50 transition-colors hover:text-foreground"
        >
          <ArrowLeft className="h-4 w-4" />
          На главную
        </Link>

        <section className="overflow-hidden rounded-[28px] border border-foreground/10 bg-card p-6 shadow-[0_24px_70px_rgba(0,0,0,0.25)] sm:p-10">
          <div className="flex h-14 w-14 items-center justify-center rounded-2xl border border-red-500/20 bg-red-600/15">
            <Search className="h-7 w-7 text-red-600 dark:text-red-400" />
          </div>

          <p className="mt-6 text-sm font-medium uppercase tracking-[0.16em] text-red-600 dark:text-red-400">
            {platform}
          </p>
          <h1 className="mt-2 text-3xl font-semibold sm:text-5xl">Игры по запросу</h1>
          <p className="mt-4 max-w-2xl text-base leading-7 text-foreground/60 sm:text-lg">
            Подберём нужную игру, уточним актуальную цену и предложим удобный вариант покупки.
            Напишите нам название игры — менеджер быстро проверит наличие и ответит вам в Telegram.
          </p>

          <a
            href={telegramHref}
            target="_blank"
            rel="noreferrer"
            className="mt-7 inline-flex w-full items-center justify-center gap-2 rounded-2xl bg-[linear-gradient(90deg,#991b1b,#dc2626)] px-6 py-3.5 text-sm font-medium text-white transition hover:opacity-90 sm:w-auto"
          >
            <MessageCircle className="h-5 w-5" />
            Узнать цену в Telegram
          </a>
        </section>
      </div>
    </main>
  );
};

export default GameRequestPage;
